import { styled, withStyle, LN2 } from '@olxeu-jobs/ui';
import { Paper } from '../paper';

export const Wrapper = withStyle(Paper, ({ $theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: $theme.space[16],
  overflow: 'hidden',
}));

export const HeaderWrapper = styled('header', ({ $theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  gap: $theme.space[8],
}));

export const Heading = withStyle(LN2, {
  margin: 0,
});
